import { render, staticRenderFns } from "./MyNavigation.vue?vue&type=template&id=f08f9820&"
import script from "./MyNavigation.vue?vue&type=script&lang=js&"
export * from "./MyNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MyNavigation.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports